export default __webpack_public_path__ + "static/media/arequipa-misti_blue_hour.e4072919.jpg";